import { EnterpriseLinkButton } from '@mews-commander/ui';
import { IconName } from '@optimus-web/core';
import { Target } from '@mews/enums';
import { lt } from '@mews/framework';

export const DownloadLink = ({ groupId }: { groupId: string }) => (
    <EnterpriseLinkButton
        to="ReservationMembership/Export/$groupId"
        params={{
            groupId,
        }}
        search={{
            layout: 'empty',
        }}
        target={Target.Blank}
        icon={IconName.Download}
        variant="ghost"
        size="small"
        iconPosition="right"
    >
        {lt('Download')}
    </EnterpriseLinkButton>
);
